import { HashErrorType } from '../../types/reset-password/HashErrorType';
import { t } from 'i18next';

export const getTitleByHashStatus = (
  hashStatus: HashErrorType
): { title: string; subtitle: string; btnLabel: string } => {
  switch (hashStatus) {
    case 'INVALID':
      return {
        title: t('invalidPasswordResetLink'),
        subtitle: t('invalidPasswordResetLinkDesc'),
        btnLabel: t('resetNow'),
      };

    case 'EXPIRED':
      return {
        title: t('expiredPasswordResetLink'),
        subtitle: t('expiredPasswordResetLinkDesc'),
        btnLabel: t('resetAgain'),
      };

    case 'VALID':
    default:
      return {
        title: t('setNewPassword') + ':',
        subtitle: t('enterYourNewPasswordBelow'),
        btnLabel: '',
      };
  }
};

export const apiErrorToText = (apiError: string): string => {
  switch (apiError) {
    case 'WRONG_HASH':
      return 'wrongHash';

    case 'OTHER_ERROR':
      return 'somethingWentWrong';

    case 'PASSWORDS_IS_NOT_THE_SAME':
      return 'passwordsIsNotTheSame';

    case 'EXPIRE_LINK':
      return 'expireLink';

    default:
      return 'failedChangePassword';
  }
};
